import React, { useEffect, useState } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import Slider from "components/Slider";
import { useQuery } from "@apollo/client";
import { GET_ALL_HOTEL_CHARGES } from "graphql/service";
import { Content, ItemContainer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";

const RatePlan = () => {

  const [hotelCharges, setHotelCharges] = useState([]);

  const { data: hotelChargesData, error } = useQuery(GET_ALL_HOTEL_CHARGES);

  useEffect(() => {
    if (hotelChargesData) {
      setHotelCharges(hotelChargesData.hotelCharges);
    }
  }, [hotelChargesData]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  return (
    <Card 
      additionalstyle={`
        height: auto;
        align-self: flex-start;
      `}
    >
      <CardHeader>
        <div className="type">HOTEL CHARGES</div>
      </CardHeader>
      <Content>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
        <ItemContainer></ItemContainer>
      </Content>
    </Card>
  );
};

export default RatePlan;
